class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    // Sommes-nous dans la variante drawer ? (wrapper rendu côté Liquid)
    this.isInDrawer = !!this.closest('.search-inline--drawer');

    if (this.input) {
      // Intercepter le reset le plus tôt possible
      this.input.form.addEventListener('reset', this.onFormReset.bind(this), true);

      // Intercepter le clic sur le bouton reset (certains thèmes agissent à ce moment)
      if (this.resetButton) {
        this.resetButton.addEventListener('click', (e) => {
          if (this.isInDrawer) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            this.clearOnly();
          }
          // sinon, laisser le reset natif pour la variante header
        });
      }

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  // Vider juste le texte, mettre à jour l’UI, garder le focus (spécifique drawer)
  clearOnly() {
    this.input.value = '';
    // notifie la predictive / UI si nécessaire
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.focus();
    this.toggleResetButton();
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const isHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && isHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !isHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    // ne pas vider si un item de predictive est sélectionné
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    if (this.isInDrawer) {
      // 🔒 Dans le drawer : on annule complètement le reset natif
      event.preventDefault();
      event.stopPropagation();
      if (!this.shouldResetForm()) return;
      this.clearOnly();
      return;
    }

    // Variante header (comportement existant mais sans réinjecter la valeur URL)
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
